"use strict";
exports.__esModule = true;
exports.useThinking = exports.createThinkingTracker = exports.THINKING_TIMEOUT_MS = exports.THINKING_AFTER_MS = void 0;
var react_1 = require("react");
// There is no "thinking" event on the socket, so it is inferred on the client:
// the user spoke, then went quiet, and the bot has not started replying yet.
exports.THINKING_AFTER_MS = 700; // silence before we assume the turn ended
exports.THINKING_TIMEOUT_MS = 10000; // no reply by then: back to listening
exports.createThinkingTracker = function (onChange) {
    var heardUser = false;
    var thinking = false;
    var armTimer = null;
    var timeoutTimer = null;
    var set = function (value) {
        if (value === thinking)
            return;
        thinking = value;
        onChange(value);
    };
    var clearTimers = function () {
        if (armTimer)
            clearTimeout(armTimer);
        if (timeoutTimer)
            clearTimeout(timeoutTimer);
        armTimer = null;
        timeoutTimer = null;
    };
    return {
        update: function (_a) {
            var isCallConnected = _a.isCallConnected, isMuted = _a.isMuted, isBotSpeaking = _a.isBotSpeaking, isUserSpeaking = _a.isUserSpeaking;
            if (!isCallConnected || isMuted || isBotSpeaking) {
                heardUser = false;
                clearTimers();
                set(false);
                return;
            }
            if (isUserSpeaking) {
                heardUser = true;
                clearTimers();
                set(false);
                return;
            }
            if (!heardUser || armTimer || thinking)
                return;
            armTimer = setTimeout(function () {
                armTimer = null;
                heardUser = false;
                set(true);
                timeoutTimer = setTimeout(function () {
                    timeoutTimer = null;
                    set(false);
                }, exports.THINKING_TIMEOUT_MS);
            }, exports.THINKING_AFTER_MS);
        },
        dispose: clearTimers,
    };
};
exports.useThinking = function (input) {
    var _a = react_1.useState(false), thinking = _a[0], setThinking = _a[1];
    var tracker = react_1.useRef(null);
    if (!tracker.current)
        tracker.current = exports.createThinkingTracker(setThinking);
    var isCallConnected = input.isCallConnected, isMuted = input.isMuted, isBotSpeaking = input.isBotSpeaking, isUserSpeaking = input.isUserSpeaking;
    react_1.useEffect(function () {
        tracker.current.update({
            isCallConnected: isCallConnected,
            isMuted: isMuted,
            isBotSpeaking: isBotSpeaking,
            isUserSpeaking: isUserSpeaking,
        });
    }, [isCallConnected, isMuted, isBotSpeaking, isUserSpeaking]);
    react_1.useEffect(function () { return function () { return tracker.current.dispose(); }; }, []);
    return thinking;
};
